<template>
  <div>     
    <v-container grid-list-md text-xs-center>
      <v-row>
        <v-col lg="6" md="12" sm="12">
          <v-card>
              <v-card-title :style="`background:${headerColor}`" class="cardTitle">
                {{ $t('dashboard.registration') }}
              </v-card-title>
              <v-card-text class="bcard">
                <v-row>
                  <v-col cols="12" md="12" class="text-center">
                    <p class="scard">{{ $t("dashboard.subtitle_card_reg") }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('event_reg')" block>{{ $t("dashboard.event_registration") }}</v-btn>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('your_reg')" block>{{ $t("dashboard.your_registration") }}</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="$store.getters.env.get('VUE_APP_HIDE_MEMBERSHIP_REG') == 0" cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('member_reg')" block>{{ $t("dashboard.membership_registration") }}</v-btn>
                  </v-col>
                  <v-col v-if="!hideEventWaiversMenu" cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('waiver_reg')" block>{{ $t("eventWaiver.title") }}</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
          </v-card>
          <v-card class="mx-auto mt-4">
              <v-card-title :style="`background:${headerColor};cursor:pointer`" class="cardTitle" @click="goPart">
                {{ $t("dashboard.participants")}}
              </v-card-title>
              <v-card-text class="bcard">
                <v-row>
                  <v-col md="12" class="text-center">
                    <p class="scard">{{ $t("dashboard.subtitle_card_part") }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('add_part')" block>{{ $t("dashboard.add_participants") }}</v-btn>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('your_part')" block>{{ $t("dashboard.your_participants") }}</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="12" sm="12">
          <v-card class="mx-auto">
              <v-card-title :style="`background:${headerColor};cursor:pointer`" class="cardTitle" @click="goProfile">
                  <v-icon class="bigIcon">fas fa-id-card</v-icon>
                  {{ $t("profile.title")}}               
              </v-card-title>
              <v-card-text class="bcard">
                <v-row>
                  <v-col cols="12" md="12" class="text-center">
                    <p class="scard">{{ $t("dashboard.subtitle_card") }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('emergency')" block>{{ $t("emergencyContact.title") }}</v-btn>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('waiver')" block>{{ $t("waivers.title") }}</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('vehicle')" block>{{ $t("vehicles.title") }}</v-btn>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('sponsor')" block>{{ $t("sponsors.title") }}</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('transponder')" block>{{ $t("transponder.title") }}</v-btn>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('social')" block>{{ $t("social.title") }}</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6" md="6" sm="12" class="text-center">
                    <v-btn :color="`${buttonColor}`" class="btn btn_layout" @click="changePage('member')" block>{{ $t("membership.title") }}</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AuthService from '../services/AuthService';
import { VContainer, VCard, VBtn, VRow, VCol, VIcon, VCardTitle, VCardText } from 'vuetify/lib';
import { mapState } from 'vuex';
import LocalStorageService from "@/services/LocalStorageService";

export default {
  name: "Dashboard",
  components:{
    VContainer, VCard, VBtn, VRow, VCol, VIcon, VCardTitle, VCardText
  },
  data() {
    return {
      dynamicMenuItems: [],
      buttonColor: "#000",
      headerColor: "#000",
      manImage: require("@/assets/images/partPlaceholder.jpg"), //change by silhouette man
      womanImage: require("@/assets/images/partPlaceholder.jpg"), //change by silhouette woman
      delay: false
    };
  },
  mounted() {
    this.$emit("titlePage", "dashboard.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);

    AuthService.getUserCurrent().then(response =>{
      if(response.data.success == 1){
        let userName = response.data.message.firstName+" "+response.data.message.lastName;
        this.$store.commit('setUserId', response.data.message.id);
        this.$store.commit('setUserName', userName);
        this.$emit("userName", userName);
      }
    }).catch(() => {});
    this.$emit("changeLoadingStep", false);
    setTimeout(() => {
      this.delay = true;
    }, 300);
  },
  computed: {
    ...mapState(['events']),
    ...mapState({
      user: (state) => state,
      loadingPage: (state) => state.session.loadingPage,
      hideWaiversMenu: (state) => state.session.hideWaiversMenu
    }),
    hideEventWaiversMenu(){
      return !this.delay || this.hideWaiversMenu;
    }
  },
  created(){
    const memberLink = LocalStorageService.getItem('link_member_reg');
		if(memberLink) {
      this.$router.push({ name: "MemberRegistration", query: { orgId: memberLink } });
		}
    const nextLink = LocalStorageService.getItem('next_link');
		if(nextLink) {
				LocalStorageService.removeItem("next_link");
        this.$router.push(nextLink);
		}
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.headerColor = this.$store.getters.env.get('VUE_APP_HEADER_COLOR');
  },
  methods: {    
    changePage(pag){
      let path = "";
      switch (pag) {
        case 'emergency':
          path = "emergencycontact";
          break;
        case 'sponsor':
          path = "sponsors";
          break;
        case 'waiver':
          path = "membershipWaivers";
          break;
        case 'vehicle':
          path = "vehicles";
          break;
        case 'transponder':
          path = "transponder";
          break;
        case 'social':
          path = "social";
          break;
        case 'registerevent':
          path = "registerEventDashboard";
          break;
        case 'event_reg': {
          LocalStorageService.removeItem('registration_legacy');
          LocalStorageService.setItem('active_event_registration', false);
          path = "registerEventLegacy";
          break;
        }
        case 'member_reg':{
          const memberReg = LocalStorageService.getItem('member_reg');
          if(memberReg){
            LocalStorageService.removeItem('member_reg');
          }
          path = "memberRegistration";
          break;
        }
        case 'your_reg':
          path = "yourRegistration";
          break;
        case 'waiver_reg':
          path = "eventWaivers";
          break;
        case 'add_part':
          path = "ridersCreate";
          break;
        case 'your_part':
          path="Riders";
          break;
        case 'member':
          path="membership";
          break;
      }
      this.$router.push({
        path: path
      });
    },
    goProfile(){
      this.$router.push({
        path: "profile"
      });
    },
    goPart(){
      this.$router.push({
        path: "Riders"
      });
    }
  }
};
</script>
<style>
  .bigIcon{
    font-size: 34px !important;
    margin-right: 10px;
    color: #fff !important;
  }
  .btn{
    color: #FFF !important;
    min-width: 210px;
  }
  .cardTitle{
    color: #FFF;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .scard{
    margin-bottom: 0 !important;
    font-size: 17px;
  }
  .bcard{
    background-color: #F4F6F7;
  }
  .v-card__title+.v-card__subtitle, .v-card__title+.v-card__text{
    padding-top: 16px !important;
  }  
  .btn_layout {
    max-width: 100%;
    display: block;
    white-space: normal;
    min-height: 36px;
    height: auto;
  }
</style>